import React from 'react'
import FeatherIcon from 'feather-icons-react'
import { getPrescriptionStatusDisplay } from 'utility/prescriptionOperationStatus.util'
import './index.scss'

const PrescriptionOperationStatus = ({ status }) => {
  if (!status) return <span>-</span>
  const display = getPrescriptionStatusDisplay(status)
  return (
    <span
      className="rx-status-badge"
      title={display.label}
      style={{ backgroundColor: display.color, color: display.textColor }}
    >
      <FeatherIcon icon={display.icon} size={13} aria-hidden="true" />
      {display.label}
    </span>
  )
}

export default PrescriptionOperationStatus
